module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-friend-2-large-942c89f9ecb6f7d27fe815ef8f08409b.jpg";